<template>
  <textarea rows="5" v-model="chatContentToBe"></textarea>

  <div class="button-wrapper">
    <div class="left">
      <ButtonProcess secondary @click="deleteMessage">문장삭제하기</ButtonProcess>
    </div>
    <div class="right">
      <ButtonProcess secondary @click="closeModalEdit">취소하기</ButtonProcess>
      <ButtonProcess @click="editMessage">수정하기</ButtonProcess>
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import { useSocketStore } from '@/stores/socket';
import { useUserStore } from '@/stores/user';
import { MessageText } from '@/types/socket';
import { ij_callLogId } from '@/utils/injectionKeys';

const props = withDefaults(
  defineProps<{
    messageDetails: MessageText;
    closeModalEdit: () => void;
    dataFlag: string;
    languageCodeSet: Set<string>;
  }>(),
  {
    messageDetails: () => ({}),
    closeModalEdit: () => {},
    dataFlag: '',
    languageCodeSet: () => new Set(),
  }
);

const socketStore = useSocketStore();
const userStore = useUserStore();

const callLogId = inject(ij_callLogId);

const chatContentToBe = ref(props.messageDetails.messageEdited || props.messageDetails.content);

const editMessage = () => {
  socketStore.sendMessageEM({
    callLogId,
    dataFlag: props.dataFlag,
    subId: props.messageDetails.chatSeqSubId,
    message: chatContentToBe.value,
    languageCode: [...props.languageCodeSet][0],
  });
  props.closeModalEdit();
};

const deleteMessage = () => {
  socketStore.sendMessageDM({ chatLogId: callLogId, userId: userStore.userId });
  props.closeModalEdit();
};
</script>

<style scoped lang="scss">
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;

  margin-top: 1rem;

  .left {
    display: flex;
  }
  .right {
    display: flex;
    gap: 0.5rem;
  }
}
</style>
